
(function(template){
    define('vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/serviceItem',['Vue','vue!./serviceDetails','vuex','helpers','vue!./serviceItemHeader', 'vue!app/views/vue/basicComponents/radioButton'],function (Vue,serviceDetails,vuex,helpers,serviceItemHeader, radioButton) {

        return {
            template:template,
            components: {
                'service-details':serviceDetails,
                'service-item-header' : serviceItemHeader,
                'radio-button': radioButton
            },
            props: ['service','package_item','focusable','index','lastIndex'],
            data: function(){
                return {
                    showMemberDropdown: false,
                    durationItem: [].concat(this.service)[0].SpaItemId,
                    accordionClicked: false
                }
            },
            computed: _.extend(vuex.mapState(['users','loggedInUser','selectedServices','activeService', 'OTBactive']),
                {
                    options: function(){
                        var vm = this;
                        return [].concat(this.service).map(function(serv){ return {
                            name: vm.currencyPrefix + serv.Price + ' | ' + serv.ServiceTime + vm.localStrings.stepper.body.pick.service.durationGrouperTimeUnit,
                            val:serv.SpaItemId
                        } });
                    },
                    getMainUser: function(){
                        return _.keys(this.users)[0];
                    },
                    serviceOrMinutes:function(){
                        if(this.package_item) return this.package_item.PackageItems.PackageItem.length +" services"
                        else return this.service.ServiceTime +  this.localStrings.stepper.body.pick.service.headerDuarationUnit
                    },
                    durItem: function(){
                        var vm = this;
                        return _.find([].concat(vm.service), function(el){
                            return el.SpaItemId == vm.durationItem
                            });
                    }
                }
            ),
            methods:  _.extend(vuex.mapMutations(['addService','setActiveService', 'removeUnbookedServices']),
                {
                    handleRadioClick: function(val){
                    this.$emit('update:selected',val)
                    },
                    handleKeyDown: function(e){
                        var vm = this;
                        this.a11yKeyDown(e, {
                            up: function() {
                                var indexToUse = vm.index == 0 ? vm.lastIndex : vm.index-1;
                                if(vm.index== indexToUse) return;
                                $('#stepper-services .serviceItemComponent a')[indexToUse].focus();
                                if(vm.index == 0) {
                                    e.preventDefault();
                                    $('#stepper-services .serviceItemComponent a')[indexToUse].scrollIntoView({block:'center',behavior: "smooth"});
                                }
                                if($('#'+vm.service.SpaItemId+'.accordion-body.in.collapse').length > 0) e.target.click();
                            },
                            down: function() {
                                var indexToUse = vm.index == vm.lastIndex ? 0 : vm.index+1;
                                if(vm.index== indexToUse) return;
                                $('#stepper-services .serviceItemComponent a')[indexToUse].focus();
                                if(vm.index == vm.lastIndex) {
                                    e.preventDefault();
                                    $('#stepper-services .serviceItemComponent a')[indexToUse].scrollIntoView({block:'center',behavior: "smooth"});
                                }
                            },
                            enter: function(){
                                e.target.click();
                            },
                            space: function() {
                                e.preventDefault();
                                e.target.click();
                            }
                        })
                    },
                    handleMultipleClick: function(userId,checked){
                        var vm = this;
                        if(!checked  && !this.singleBookingMode){
                            this.removeServiceForUser(userId);
                           return;
                        }

                        if(this.service.length){
                            var durationServiceObj = _.filter(this.service, function(el){return el.SpaItemId == vm.activeService})[0]
                            this.addService({service:durationServiceObj, userId:userId, setSelected:checked, package_item:this.package_item})
                            if(app.customization.googleAnalytics){
                                helpers.analyticsInit('serviceClick', [durationServiceObj])
                            }
                        }else{
                            this.addService({service:this.service, userId:userId, setSelected:checked, package_item:this.package_item})
                            if(app.customization.googleAnalytics){
                                helpers.analyticsInit('serviceClick', [this.service])
                            }
                        }
                    },
                    hide: function(){
                            if(this.showMemberDropdown==true)  this.showMemberDropdown = false;
                    },
                    handleSingleAdd: function(checked){
                        if(this.OTBactive && this.selectedServices[this.activeService]) return;
                        if(this.OTBactive && (this.$store.state.status != 'E')){
                            checked = true;
                            this.accordionClicked = true;
                            this.removeUnbookedServices();
                        }
                        if(!checked && !this.singleBookingMode){
                           this.removeServiceForUser(this.loggedInUser);
                           return;
                        }
                        this.addService({service:this.durItem, userId:Object.keys(this.users)[0], setSelected:checked, package_item:this.package_item})

                        if(this.OTBactive){
                            var ageCheck = this.verifyAge(this.durItem, Object.keys(this.users)[0])
                            this.$store.commit('setIsAgeValid', ageCheck.isValid);
                        }
                        if(app.customization.googleAnalytics){
                            helpers.analyticsInit('serviceClick', [this.durItem])
                        }
                    },
                    removeServiceForUser: function(userId){
                        var vm = this;
                        userId = userId || app.data.DefaultCustomerId;
                        _.keys(vm.users[userId]).forEach(function(key){
                            var SpaItemId = vm.service.SpaItemId;
                            if(key.split('-')[0] == SpaItemId) {
                                var service = vm.users[userId][key]
                                helpers.removeService( service.SpaFolioItemId, SpaItemId, key, userId, service.packageItem );
                            }
                        })
                    },
                    selected: function(userId){
                        var vm = this;
                        if(!userId){
                            return vm.selectedServices[vm.service.SpaItemId] && Object.keys(vm.users).length == 1;
                        }
                        if (this.singleBookingMode) {
                            return _.values(this.users[userId]).some(function (item) {
                              return (item.service||{}).SpaItemId == vm.service.SpaItemId && !item.SpaFolioItemId
                             })
                        } else {
                             return _.keys(this.users[userId]).some(function (item) {
                                 return item.split('-')[0] == vm.service.SpaItemId;
                            })
                        }
                    },
                    serviceCount: function(userId){
                        var vm = this
                        return Object.keys(this.users[userId]).filter(function(x){return vm.service.SpaItemId == x.split('-')[0]}).length;
                    }
                }
            ),
            watch: {
                durationItem: function(){
                    if(this.OTBactive && (this.$store.state.status != 'E') && this.customization.allowDurationGrouper){
                        this.handleSingleAdd(true);
                    }
                }
            },
            events: {
                handleOutsideClick: function (event) {
                    this.showMemberDropdown = false
                }
            },
        }
    });
})('<div class="accordion-group serviceItemComponent " tabindex="-1"> <div v-if="OTBactive && (this.$store.state.status != \'E\')" class="accordion-heading" tabindex="-1"> <a v-if="service.length" aria-expanded="false" :aria-controls="durItem.SpaItemId" :class="[\'accordion-toggle collapsed\',{active: durItem.SpaItemId == activeService}]" data-toggle="collapse" data-parent="#accordion2" @click="setActiveService(durItem.SpaItemId), handleSingleAdd()" @keydown="handleKeyDown" :href="\'#\'+durItem.SpaItemId" tabindex=\'0\'> <service-item-header :service="durItem" :selected="selected()" :package_item="package_item" :active="durItem.SpaItemId == activeService" ></service-item-header> </a> <a v-else-if="service.SpaItemId" aria-expanded="false" :aria-controls="durItem.SpaItemId" :class="[\'accordion-toggle collapsed\',{active: service.SpaItemId == activeService}]" data-toggle="collapse" data-parent="#accordion2" @click="setActiveService(service.SpaItemId), handleSingleAdd()" @keydown="handleKeyDown" :href="\'#\'+service.SpaItemId" tabindex=\'0\'> <service-item-header :service="service" :selected="selected()" :package_item="package_item" :active="service.SpaItemId == activeService" ></service-item-header> </a> </div> <div v-else class="accordion-heading" tabindex="-1"> <a v-if="service.length" aria-expanded="false" :aria-controls="durItem.SpaItemId" :class="[\'accordion-toggle collapsed\',{active: durItem.SpaItemId == activeService}]" data-toggle="collapse" @click="setActiveService(durItem.SpaItemId)" @keydown="handleKeyDown" :href="\'#\'+durItem.SpaItemId" tabindex=\'0\' data-parent="#accordion2"> <service-item-header :service="durItem" :selected="selected()" :package_item="package_item" :active="durItem.SpaItemId == activeService" ></service-item-header> </a> <a v-else-if="service.SpaItemId" aria-expanded="false" :aria-controls="durItem.SpaItemId" :class="[\'accordion-toggle \',{active: service.SpaItemId == activeService}]" data-toggle="collapse" @click="setActiveService(service.SpaItemId)" @keydown="handleKeyDown" :href="\'#\'+service.SpaItemId" tabindex=\'0\' data-parent="#accordion2" > <service-item-header :service="service" :selected="selected()" :package_item="package_item" :active="service.SpaItemId == activeService" ></service-item-header> </a> </div> <div :id="durItem.SpaItemId" role="region" :aria-label="service.ItemName || service.serviceName" class="accordion-body collapse " style="height: 0px; display: none;"> <div class="accordion-inner"> <div v-if="service.length" class="durationSelector"> <radio-button :options="options" :selected.sync="durationItem" @setActiveServ="setActiveService($event)" ></radio-button> </div> <service-details :package_item="package_item" :service="durItem" :selected="!!selectedServices[durItem.SpaItemId]" :users="users" @handle-Multiple-Click="handleMultipleClick" @handle-Single-Add="handleSingleAdd" @service-Count="serviceCount" @selected="selected" ></service-details> </div> </div> </div>');
